import React, { useEffect, useState } from 'react';
import { simpleNotification } from '../../../utils/notifications';
import RecoverForm from '../../forms/RecoverForm';
import RecoverPasswordForm from '../../forms/RecoverPasswordForm';
import LoginModal from '../LoginModal';
import '../login.scss';
import './Recover.scss';

function Recover({ auth, location, recover, recoverChangePassword, recoverValidate, router }) {
  const [authToken, setAuthToken] = useState(null);
  const [showingErrors, setShowingErrors] = useState(false);
  const [showingSuccess, setShowingSuccess] = useState(false);
  const recoveryToken = location.query['recovery-token'];

  // Handle error/success states
  useEffect(() => {
    if (auth.isLoading === false) {
      if (auth.errors.hasError) {
        if (showingSuccess) setShowingSuccess(false);
        if (!showingErrors) setShowingErrors(true);
      } else {
        if (showingErrors) setShowingErrors(false);
        if (auth.recoverSuccess && !showingSuccess) setShowingSuccess(true);
      }
    }
  }, [auth]);

  // Notify of successful password recovery and redirect
  useEffect(() => {
    if (authToken === null) {
      setAuthToken(auth.token);
      return;
    }

    if (authToken !== auth.token) {
      simpleNotification({
        level: 'success',
        title: 'Password Recovered.',
        message: 'Your password has been recovered successfully.',
      });
      router.replace('/');
      return;
    }

  }, [auth, authToken]);

  // Validate recovery token
  useEffect(() => {
    if (recoveryToken) recoverValidate(recoveryToken);
  }, [recoveryToken, recoverValidate]);

  const recoverTabs = [
    {
      label: 'RECOVER',
      url: '/recover',
    }
  ];

  return (
    <section className="Recover LogIn">
      <LoginModal className="Recover" tabs={recoverTabs}>
        {recoveryToken &&
          <RecoverPasswordForm
            onSubmit={allFields => {
              const { password, rePassword } = allFields;
              recoverChangePassword(recoveryToken, password, rePassword);
            }}
          />
        }
        {!recoveryToken && <RecoverForm onSubmit={identity => recover(identity)} />}
        <section className={`errors-container ${showingErrors ? 'active' : ''}`}>
          <div className="error-message">
            {auth.errors.message}
          </div>
          <button
            className="error-dismiss"
            onClick={() => setShowingErrors(false)}
            type="button"
          />
        </section>
        <section className={`success-container ${(showingSuccess & !recoveryToken) ? 'active' : ''}`}>
          <div className="success-message">
            We sent you an email to retrieve your password. Sometimes this email may take a couple of minutes before it reaches your mailbox.
          </div>
          <button
            className="success-dismiss"
            onClick={() => setShowingSuccess(false)}
            type="button"
          />
        </section>
      </LoginModal>
    </section>
  )
};

export default Recover;
